<template>
  <div class="test-content">
    <div v-if="!previewPdf">
      <div v-if="enterTreasure">
        <ul class="treasure-box">
          <li class="treasure-list" v-for="(item,index) in TreasureName" @click="handleTreasure(index)">
            <span>{{item}}</span>
          </li>
        </ul>
        <div class="errorMessage">{{errorMessage}}</div>
        <div class="button-box">
          <button class="default-btn large-btn" @click="emitBackActivities" >返回活动广场</button>
        </div>
      </div>
      <div>
        <div v-if="current==1">
          <CareerSearch v-on:listenToChildEvent="handleBackTreasure"></CareerSearch>
        </div>
        <div v-if="current==2">
          <TreasureQuality v-on:listenToChildEvent="handleBackTreasure"/>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="wrap" style="display: flex;  flex-direction: column; align-items: center;">
        <iframe :src="pSrc" width="100%" height="92%"></iframe>
        <div class="button-box">
          <button class="default-btn large-btn" @click="handleBackTreasure">返回多宝库</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CareerSearch from '@/page/CareerSearch.vue'
import TreasureQuality from '@/page/TreasureQuality.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default{
  props: {
  },
  name: 'Treasure',
  components: {
    'CareerSearch':CareerSearch,
    'TreasureQuality':TreasureQuality
  },
  data(){
    return{
      id: 97, //多宝库特定号码
      TreasureName:['职业检索库','素质库','毕业政策合集-资源推荐','毕业去向SWOT分析'],
      current:0,
      enterTreasure:true,
      pSrc:'',
      previewPdf: false,
      errorMessage:''
    }
  },
  computed: {
    ...mapState({
      currentGroupMemberNum: state => state.conversation.currentGroupMemberNum,
      arrCosPlay: state => state.shengyaUser.arrCosPlay,
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
		partnerCode() {
			return this.shengyaUser.admin.manageAccCode.replace('admin','')
		},
		groupID() {
			return this.partnerCode+'-cos-mission-97'
		}
  },
  created(){
    setWechatTitle('生涯驿站-多宝库');
  },
  methods:{
    // 跳转到对应的模块
    handleTreasure(index){
      if(index<2) {
        if((index==0&&parseInt(this.arrCosPlay[5]))||(index==1&&parseInt(this.arrCosPlay[8]))){
          this.errorMessage=""
          this.enterTreasure = false
          this.current = index+1
        }else{
          if(index){
            this.errorMessage = "请先完成第9关-目标职位能力大赏"
          }else{
            this.errorMessage = "请先完成第6关-职业倾向匹配"
          }
        }

      }else{
        this.loadPDF(index)
      }
    },
    // 返回多宝库
    handleBackTreasure(){
      this.previewPdf = false
      this.enterTreasure = true
      this.current = 0
    },
    //返回广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
      this.$bus.$emit('back-activities')
    },
    loadPDF (index) {
      this.previewPdf = true
      //pdfurl ：pdf存放的文件路径，可以是本地的，也可以是远程，这个是远程的，亲测可以用
      let pdfurl = '';
      if(index ==2)
        pdfurl = 'http://sys.rennengda.com/public/doc/11-graduate-policy.pdf'
      else
        pdfurl = 'http://sys.rennengda.com/public/doc/12-graduate-goes.pdf'
      // const host = window.location.host
      // const pathname = window.location.pathname
      const baseUrl = 'http://'+ window.location.host+ window.location.pathname
      let pSrc = pdfurl + '?r=' + new Date().getTime(); //防缓存
      this.pSrc ='http://sys.rennengda.com/public/pdfjs/web/viewer.html?file=' + encodeURIComponent(pSrc);
    },
  }
}
 </script>
<style lang="stylus" scoped>
  .onlineInfo
    text-align: right
    margin: 0.14rem 0.58rem 0.14rem 1rem
    color: #777
    font-size: 0.24rem;
    .number
      color: #FB8D3E
      font-size: 0.28rem;
  .treasure-box
    overflow:hidden
    .treasure-list
      float:left
      width:36%
      height:1.2rem
      font-size:0.36rem
      margin:0.2rem
      padding:0.2rem
      color:#ffffff
      display: flex
      display:-webkit-flex;
      justify-content: center/*水平居中*/
      align-items: center/*垂直居中*/
      -webkit-align-items:center
    .treasure-list:nth-child(1)
      background-color:#8C0061
    .treasure-list:nth-child(2)
      background-color:#F15769
    .treasure-list:nth-child(3)
      background-color:#FAD309
    .treasure-list:nth-child(4)
      background-color:#C1D659

  .wrap
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  .errorMessage
    text-align:center
    margin-top:0.5rem
    font-size:0.32rem
  .button-box .disabled-btn
    background :#BBBBBB
</style>
